import React from 'react';
import styled from 'styled-components';
import { BACKGROUNDS } from 'themes/';
import FlexWrapper from 'ui/FlexWrapper';
import { FilledWrapper } from 'ui/Wrapper';
import CloseIcon from 'images/icons/edit.png';

const PopupWrapperStyled = styled.div`
    width: 800px;
    height: 666px;
    border-radius: 15px;
    box-shadow: 0px 0px 80px rgba(0, 0, 0, 0.5);
    background: ${BACKGROUNDS.white};
    overflow: hidden;
    position: relative;
    padding: 0px;
    margin: 0px auto;
`;

const CloseModalBtnStyled = styled.div`
    width: 20px;
    height: 20px;
    background: url(${CloseIcon}) center center no-repeat;
    background-size: 14px;
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
    z-index: 1;
`;

const PopupWrapper = (props) => {
    const { MenuView, ContentView, TitleView } = props.children;

    return (
        <FlexWrapper direction="column">
            <PopupWrapperStyled>
                <CloseModalBtnStyled onClick={props.onClickCloseBth} />

                <FlexWrapper padding="0px" direction="row">
                    <FilledWrapper width="250px" padding="0px" grey>
                        {MenuView}
                    </FilledWrapper>

                    <FilledWrapper
                        width="550px"
                        padding="10px"
                        white
                        style={{ overflowY: 'auto' }}
                    >
                        {TitleView}
                        {ContentView}
                    </FilledWrapper>
                </FlexWrapper>
            </PopupWrapperStyled>
        </FlexWrapper>
    );
};

export default PopupWrapper;
